import type { IAnalyticsProvider } from '@cmoh/shared'
import { env } from '@/config/env'
import { PostHogProvider } from './posthog-provider'
import { NoOpProvider } from './noop-provider'

/**
 * Analytics service singleton
 * Provides centralized access to analytics provider
 */
class AnalyticsService {
  private provider: IAnalyticsProvider

  constructor() {
    this.provider = env.analytics.enabled
      ? new PostHogProvider()
      : new NoOpProvider()
  }

  /**
   * Initialize analytics
   * Call this once when app starts
   */
  init(): void {
    this.provider.init()
  }

  /**
   * Get the current provider instance
   */
  getProvider(): IAnalyticsProvider {
    return this.provider
  }
}

export const analyticsService = new AnalyticsService()

export const analytics = analyticsService.getProvider()
